<template lang="pug">
  .container
    .header
      img.banner(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/shaanxi/vx-flow-banner-2.png")
    .tip
      p 尊敬的用户，您好
      p 您的业务已办理成功
    .ad-notice
      .title 限时福利
      .content
        p 邀请好友领取成功后得5元微信红包
        p 最多可领20次，红包立即到账
    .share-ad
        div 点击下方图片邀请好友免费体验领取100元红包
        img(@click="shareNoticeVisiable = true", src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/shaanxi/sharebanner.png")
        div 点击上方图片邀请好友免费体验领取100元红包
    .share-dialog(v-if="shareNoticeVisiable", @click="shareNoticeVisiable = false")
      img(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/shaanxi/share-dialog.png")
</template>

<script>
export default {
  data() {
    return {
      shareNoticeVisiable: false
    }
  }
}
</script>

<style lang="less" scoped>
.container{
  background-color: #b6f7e1;
  padding-bottom: 3.5rem;
  min-height: 700px;
}
.header{
  .banner{
    width: 100%;
  }
}
.tip{
  font-size: 1.2rem;
  margin: 2rem 0 5rem 0;
  color: Green;
  text-align: center;
}
.share-ad{
  position: fixed;
  bottom: 1rem;
  text-align: center;
  color: #a3a3a3;
  font-size: .9rem;
  img{
    width: 94%;
  }
}
.share-dialog{
  position: fixed;
  z-index: 10;
  top: 0px;
  right: 0px;
  background-color: rgba(0,0,0,.8);
  width: 100%;
  height: 900px;
}
.ad-notice{
  text-align: center;
  .title{
    color: red;
    font-size: 1.2rem;
  }
}
</style>